import React from "react"
import { compose, defaultProps } from "recompose"
import get from "lodash/get"

import { Box } from "@infotech/uikit-grid"

import EventConnectedInfo, { Modal } from "../EventConnectedInfo"
import withModalState from "./hocs/withModalState"
import styles from "./styles.css"

/**
 * Компонент EventCardConnectedInfo - виджет в карточке события
 *
 * @param {string} token
 * @param {object} eventData
 * @param {string} eventData.uuid
 * @param {number} eventData.startDateTime
 * @param {number} eventData.endDateTime
 * @param {string} currentResourceUuid
 * @param {array} resourcesData
 *
 */

const EventCardConnectedInfo = ({
  /* eslint-disable */
  eventData,
  currentResourceUuid,
  resourcesData,
  modalProps,

  isOpen,
  buttonConf,
  onCancel,
  toggleOpen,
  /* eslint-enable */
}) => {
  return (
    <div>
      <div className={styles.Rectangle} />
      <Box loose pt="2md" pb="2md">
        <span className={styles.ConnectedInfoLink} onClick={toggleOpen}>
          Информация по планированию
        </span>
        <Modal
          isOpen={isOpen}
          buttonConf={buttonConf}
          onCancel={onCancel}
          title="Информация по планированию"
          noFooter
          hasOverlay
          isMenuVisible={modalProps.isMenuVisible}
          areMenuCaptionsVisible={modalProps.areMenuCaptionsVisible}
          SIDEBAR_WIDTH={modalProps.SIDEBAR_WIDTH}
          SIDEBAR_COMPACT_WIDTH={modalProps.SIDEBAR_COMPACT_WIDTH}
        >
          <EventConnectedInfo
            eventData={{
              uuid: get(eventData, `uuid`),
              startDateTime: get(eventData, `startDateTime`),
              endDateTime: get(eventData, `endDateTime`),
            }}
            resourcesData={resourcesData}
          />
        </Modal>
      </Box>
    </div>
  )
}

const enhance = compose(
  defaultProps({
    modalProps: {
      SIDEBAR_WIDTH: 259,
      SIDEBAR_COMPACT_WIDTH: 56,
      isMenuVisible: true,
      areMenuCaptionsVisible: false,
    },
  }),
  withModalState,
)
export default enhance(EventCardConnectedInfo)
